// extracted by mini-css-extract-plugin
export default {"header":"Header_header__jpJUR","headerSection":"Header_headerSection__lIyOO","language":"Header_language__kpvWD","active":"Header_active__4g2Tr","logo":"Header_logo__7O5lY"};